import {DataTableColumn} from "mantine-datatable";
import {NavLink} from "react-router-dom";
import {I18n} from "@aws-amplify/core";

import {OrganizationAccount} from "../types";
import {
    formatTimestamp,
    TIMESTAMP_PLACEHOLDER
} from "../../../utils/TableTimestamps.tsx";
import {OrganizationAccountStatusBadge} from "../profile/OrganizationAccountStatusBadge.tsx";

// FNP-562: moved off the bare `tables/columns.tsx` array, which had `render`
// only. `render` decides how a cell LOOKS; `accessor` is what sorting sorts BY,
// so a render-only config makes sorting structurally impossible no matter what
// the table is wired to.
//
// The Account column sorts on `accountId` rather than the displayed email. The
// cell falls back to the id when `account` is absent, so sorting on the email
// would reorder rows by a value half of them do not show.
export const useOrganizationAccountsTableColumns = () => {

    const columns: DataTableColumn<OrganizationAccount>[] = [
        {
            accessor: 'accountId',
            title: I18n.get('Account'),
            sortable: true,
            width: '1fr',
            render: (item: OrganizationAccount) => (
                <NavLink to={`/accounts/${item.accountId}`}>
                    {item.account ? item.account.email : item.accountId}
                </NavLink>
            ),
        },
        {
            accessor: 'organizationAccountStatus',
            title: I18n.get('Status'),
            sortable: true,
            width: '1fr',
            render: (item: OrganizationAccount) => <OrganizationAccountStatusBadge record={item}/>,
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            sortable: true,
            width: '1fr',
            render: (item: OrganizationAccount) => item.created
                ? formatTimestamp(item.created)
                : TIMESTAMP_PLACEHOLDER,
        },
    ];

    return {
        columns,
    };
};
